import { fetchConfig, fetchPingInformation } from '@/vuex/modules/config/config.utils';

export function getInitialState () {
    return {
        isProduction: false,
        hosts: {},
        insertBackendDomainName: null,
        pingInformation: {},
        fetching: false,
        error: null,
    };
}

const config = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setConfig (state, { config }) {
            Object.keys(config).forEach((key) => {
                state[key] = config[key];
            });
        },
        setPingInformation (state, { pingInformation }) {
            state.pingInformation = pingInformation;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        init ({ dispatch }) {
            dispatch('getConfig');
            dispatch('getPingInformation');
        },
        async getConfig ({ commit }) {
            try {
                commit('setFetching', { fetching: true });
                const config = await fetchConfig();
                commit('setConfig', { config });
                commit('setFetching', { fetching: false });
            } catch (error) {
                commit('setError', { error });
                commit('setFetching', { fetching: false });
            }
        },
        async getPingInformation ({ commit }) {
            try {
                commit('setFetching', { fetching: true });
                const pingInformation = await fetchPingInformation();
                commit('setPingInformation', { pingInformation });
                commit('setFetching', { fetching: false });
            } catch (error) {
                commit('setError', { error });
                commit('setFetching', { fetching: false });
            }
        },
    },
};

export default config;
